<template>
  <div id="app" class="bg-gray-200">
    <div
      v-if="appLoading && !loadingError"
      class="loading-app text-center d-flex align-items-center justify-content-center"
      style="height: 100vh"
    >
      <div class="lds-ellipsis" style="margin-top: 30vh">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div>
        <img :src="logo" height="50px" class="animate-logo" />
      </div>
    </div>
    <div v-else-if="loadingError" class="loading-app">
      <div style="margin-top: 35vh">
        <b-button @click="loadUser" variant="light" class="w-100">
          Network error, click to retry
        </b-button>
      </div>
      <div>
        <img :src="logo" height="50px" class="animate-logo" />
      </div>
    </div>
    <div v-else :class="pageClass">
      <component :is="layout">
        <router-view />
      </component>
    </div>
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<script>
import { smoothScroll } from "@/utils/helpers";
import { mapState, mapActions } from "vuex";
import { isUserLoggedIn } from "@/utils/auth";

export default {
  name: "app",
  data() {
    return {
      appLoading: false,
      loadingError: false,
      logo: require("@/assets/icons/logo-dark.svg"),
      networkErrorTimeout: null,
    };
  },
  async created() {
    if (isUserLoggedIn()) {
      await this.loadUser();
    }

    this.$Progress.start();
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress;
        this.$Progress.parseMeta(meta);
      }
      this.$Progress.start();
      next();
    });
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach(() => {
      // this.tickUserObj();
      this.$Progress.finish();
      smoothScroll(1000);
    });

    this.$Progress.finish();

    let getCart = JSON.parse(localStorage.getItem("CART_ITEMS"));
    if (getCart) {
      this.$store.dispatch("unclearedCart", getCart);
    }
  },
  computed: {
    ...mapState(["userObj"]),
    layout() {
      return this.$route.meta.layout || "public";
    },
    pageClass() {
      return this.$route.name + "-page";
    },
  },
  // watch: {
  //   userObj: {
  //     handler: function(newValue) {
  //       if (newValue) {
  //         // Bounce Non Investors User
  //         // if (
  //         //   this.$route.meta.forNonInvestors == undefined &&
  //         //   this.$route.meta.requiresAuth
  //         // ) {
  //         //   if (
  //         //     this.userObj.eventcode == null &&
  //         //     !this.userObj.is_stakeholder
  //         //   ) {
  //         //     this.$bvToast.toast("Please Invest To Proceed", {
  //         //       autoHideDelay: 5000,
  //         //       appendToast: true,
  //         //       variant: "danger"
  //         //     });
  //         //     this.$router.replace({ name: "investments" });
  //         //   }
  //         // }
  //       }
  //     },
  //     deep: true,
  //     immediate: false
  //   }

  // },
  methods: {
    ...mapActions(["tickUserObj"]),
    ...mapActions("auth", ["getUserInfo"]),

    async loadUser() {
      this.loadingError = false;
      this.appLoading = true;
      try {
        await this.getUserInfo();
      } catch (error) {
        if (
          error.name == "NetworkException" &&
          ![401, 403].includes(error.status)
        )
          this.loadingError = true;
      } finally {
        this.appLoading = false;
      }
    },

    // mounted(){
    //   let getCart = JSON.parse(localStorage.getItem('CART_ITEMS'));
    //   alert('hey')
    //   if(getCart){
    //     alert('hello')
    //     this.$$store.dispatch('unclearedCart',getCart)
    //   }
    // }
  },
};
</script>

<style lang="scss">
#app {
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
